import { useEffect, useRef, useState } from "react";
import { convertAssetIDToLocalTime, convertTimeToAssetId, findClosestTimepoint } from "../../../utils/timeRelatedFunctions"
import { checkAssetIdExistence  } from "../api/checkAssetId";
import { calculatedTimeType } from "../types";

const numOfGeeTilesToFetch = 12 // 3hおきにDSが回る+1回で36h分が計算されるのでこの値を11以下にしておけば理論上は抜け漏れがない

type args = {
  calculatedTime: calculatedTimeType; // これは現地時間で入ってくることに注意！
  setCalculatedTime: React.Dispatch<React.SetStateAction<calculatedTimeType>>
}

export const useCheckImgeIdExistence = ({calculatedTime, setCalculatedTime}:args) => {
  const [imageIdList, setImageIdList] = useState<string[]>([]) // 時間幅36hは2つ以上のimage_idにまたがる可能性があるため直近の起算時刻は2つ以上取得しておく。
  const [isImageIdChecking, setIsImageIdChecking] = useState<boolean>(false)
  const initializedCalculatedTimeRef = useRef<number | null>(null)

  const createAssetIdList = (fromDate:Date|null) => {
    let assetIDList: string[] = []
    const baseDate = fromDate ? fromDate : new Date();

      for (let i = 0; i < numOfGeeTilesToFetch; i ++ ){
    // 3時間前を遡る. 
    const dateBeforeThreeHours = new Date(baseDate.getTime() - i * 3 *  60 * 60 * 1000);
    const previousCalcTime = findClosestTimepoint(dateBeforeThreeHours);
    // previousCalcTimeをUTCに変換してassetIDに変換
    const assetID = convertTimeToAssetId(previousCalcTime)
    assetIDList.push(assetID)
     }
     return assetIDList
  }
  
  useEffect(() => {
    if (!!calculatedTime && initializedCalculatedTimeRef.current === calculatedTime.getTime()) {
      initializedCalculatedTimeRef.current = null
      return
    }

    // スライダーの下限が-12hなので、現在時刻より12h以上前の起算時刻の場合はそのタイルだけを取得する. 
    // 逆にそうでない場合は、それ以前のタイルも取得する必要があるので, 3hおきに取得する後続の処理に移る.
    if (!!calculatedTime && (new Date(calculatedTime).getTime() < new Date().getTime() - 12 * 60 * 60 * 1000)){
      const tmpImageId = convertTimeToAssetId(calculatedTime)
      // ここはあったら指定にすれば良い. 
      setImageIdList([tmpImageId])
      return
    } else if (!!calculatedTime){
      // 起算時刻は指定されているが起算時刻以前のデータも必要な場合
      const assetIDList = createAssetIdList(calculatedTime)
      setImageIdList(assetIDList)
      return
    }

    // calculatedTimeが特別に指定されていない時（通常時）の挙動. 
    // {{numOfGeeTilesToFetch}}個分のデータを取得してあるものをリストに格納して返す. 
    const assetIDList = createAssetIdList(null)
    
    setIsImageIdChecking(true)
    checkAssetIdExistence({assetIdList:assetIDList}).then((res) => {
      if (!res || res.length < 1){
        // Assetがない場合はcalculatedTimeを指定しない
        setCalculatedTime(null)
        setImageIdList([])
        setIsImageIdChecking(false)
        return
      }

      // 直近の起算時刻があった場合
      const sortedPaths = res.sort((a,b) => {
        const dateA = a.substring(10); // "te_flddph_" 以降の日付部分を取得
        const dateB = b.substring(10);
        return dateB.localeCompare(dateA); 
      })
      setImageIdList(sortedPaths)
      const initializedCalculatedTime = convertAssetIDToLocalTime(sortedPaths[0])
      initializedCalculatedTimeRef.current = initializedCalculatedTime?.getTime() || null
      setCalculatedTime(initializedCalculatedTime)
      setIsImageIdChecking(false)
    })
  },[calculatedTime])

  return {imageIdList, isImageIdChecking}
}